import { createAsyncThunk } from '@reduxjs/toolkit';
import { postApi } from 'redux/apis';
import { showNotification } from 'utils/notification';

export const locationAction = createAsyncThunk(
    'location/get',
    async (_, { rejectWithValue }) => {
        try {
            const response = await postApi('/quickbooks/locations', {
                companyId: localStorage.getItem('companyId'),
            });
            return response.data.data;
        } catch (error: any) {
            if (
                error?.response?.data?.message ===
                'QuickBooks session expired. Please reconnect your company to continue.'
            ) {
                showNotification({
                    type: 'error',
                    message: 'Session Expired',
                    description: error.response.data.message,
                });
            }
            return rejectWithValue(error?.response?.data);
        }
    }
);


export const locationOptionsAction = createAsyncThunk(
    'locationOptions/get',
    async (_, { rejectWithValue }) => {
        try {
            const response = await postApi('/quickbooks/location-options', {
                companyId: localStorage.getItem('companyId'),
            });
            return response.data.data;
        } catch (error: any) {
            if (
                error?.response?.data?.message ===
                'QuickBooks session expired. Please reconnect your company to continue.'
            ) {
                showNotification({
                    type: 'error',
                    message: 'Session Expired',
                    description: error.response.data.message,
                });
            }
            return rejectWithValue(error?.response?.data);
        }
    }
)